"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _functions = require("../functions");
var _link = require("@berlitz/link");
var _list = require("@berlitz/list");
var _polished = require("polished");
var _styledComponentsRtl = _interopRequireDefault(require("styled-components-rtl"));
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var StyledRichText = _styledComponents.default.div.withConfig({
  displayName: "RichTextstyle__StyledRichText",
  componentId: "sc-1d1x1ie-0"
})(["", ";"], function (_ref) {
  var _ref$theme = _ref.theme,
    space = _ref$theme.space,
    typography = _ref$theme.typography,
    fontWeight = _ref$theme.fontWeight,
    sm = _ref$theme.breakpoints.sm,
    colors = _ref$theme.colors;
  return (0, _styledComponents.css)(["h1,h1 span{", "}h2,h2 span{", "}h3,h3 span{", "}h4,h4 span{", "}h5,h5 span{", "}strong,strong span{font-weight:", ";}em{font-style:italic;}u{text-decoration:underline;}del{text-decoration:line-through;}a:not([data-key='max-button'],.btn){font-size:inherit;", "}blockquote{", "}img{max-width:100%;margin-bottom:", ";}audio{display:block;margin-bottom:", ";}.video-16x9{display:block;position:relative;padding-top:56.25%;margin-bottom:", ";iframe{position:absolute;top:0;left:0;width:100%;height:100%;}}li{", " > *:last-child{margin-bottom:0;}}> ul:last-child{padding-bottom:0;}ul{", ";margin-bottom:", ";", " > *:last-child{margin-bottom:0;padding-bottom:0;}ul{padding-top:", ";padding-bottom:0;}}ol{", ";margin-bottom:", ";", " ol{padding-top:", ";padding-bottom:0;}}p{", "}span{", "}table{width:100%;td,th{font-size:", ";padding:", ";text-align:left;}th{color:", ";font-weight:", ";border-bottom:solid 1px ", ";}td{font-weight:", ";color:", ";background-color:", ";}tr:nth-child(even):not([class^='color-']){> td:not([class^='color-']){background-color:", ";}}tr.color-brand,td.color-brand{&,> td{background-color:", ";color:", ";}}tr.color-white,td.color-white{&,> td{background-color:", ";color:", ";}}tr.color-gray,td.color-gray{&,> td{background-color:", ";color:", ";}}tr.color-success,td.color-success{&,> td{background-color:", ";color:", ";}}tr.color-warning,td.color-warning{&,> td{background-color:", ";color:", ";}}tr.color-danger,td.color-danger{&,> td{background-color:", ";color:", ";}}.rich-text-audio-button{margin-bottom:0;}}.btn{background-color:", ";border-radius:", ";color:", "! important;font-weight:", ";padding:", " ", ";background-image:none !important;background-position:center !important;-webkit-transition:background 0.8s;-moz-transition:background 0.8s;-ms-transition:background 0.8s;-o-transition:background 0.8s;text-decoration:none;transition:background 0.8s;&:focus{background-color:", " !important;}&:hover{background:", " -webkit-radial-gradient( circle,transparent 1%,", " 1% ) center/15000% !important;background:", " -moz-radial-gradient( circle,transparent 1%,", " 1% ) center/15000% !important;background:", " -ms-radial-gradient( circle,transparent 1%,", " 1% ) center/15000% !important;background:", " -o-radial-gradient( circle,transparent 1%,", " 1% ) center/15000% !important;background:", " radial-gradient( circle,transparent 1%,", " 1% ) center/15000% !important;}&:active{background-color:", ";background-size:100% !important;-webkit-transition:background 0s;-moz-transition:background 0s;-ms-transition:background 0s;-o-transition:background 0s;transition:background 0s;}}hr{border:0;margin-bottom:", ";height:1px;background-color:", ";}.rich-text-audio-button{cursor:pointer;padding:", ";border-radius:50%;background-color:", ";color:", ";margin-bottom:", ";display:inline-block;width:42px;height:42px;position:relative;transition:", ";overflow:hidden;.play-icon{opacity:1;transform:translate(-8px,-12px);transition:", ";position:absolute;font-size:18px;}.pause-icon{opacity:0;transform:translate(-11px,20px);font-size:12px;transition:", ";position:absolute;}&.playing{.play-icon{opacity:0;transform:translate(-8px,-24px);}.pause-icon{opacity:1;transform:translate(-11px,-7px);}}&:hover{transform:scale(1.1);color:", ";background-color:", ";}&:active{transform:scale(1);background-color:", ";}}"], (0, _functions.getFontStyle)(typography['h1'], sm), (0, _functions.getFontStyle)(typography['h2'], sm), (0, _functions.getFontStyle)(typography['h3'], sm), (0, _functions.getFontStyle)(typography['h4'], sm), (0, _functions.getFontStyle)(typography['h5'], sm), fontWeight.bold, function (_ref2) {
    var inverse = _ref2.inverse;
    return inverse ? (0, _styledComponents.css)(["", ""], _link.linkStyleInverse) : (0, _styledComponents.css)(["", ""], _link.linkStyle);
  }, function (_ref3) {
    var theme = _ref3.theme;
    return (0, _styledComponents.css)(["", ";", " margin-top:", ";position:relative;&::before{content:'\u201C';", " ", ";position:absolute;top:-", ";color:", ";font-size:", ";}&::after{content:'\u201D';", ";position:absolute;color:", ";font-size:", ";", "}"], (0, _functions.getFontStyle)(theme.typography['blockquote'], sm), (0, _styledComponentsRtl.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n          padding-left: ", ";\n        "])), function (_ref4) {
      var theme = _ref4.theme;
      return "".concat(theme.space.xxl);
    }), theme.typography.blockquote.marginBottom, (0, _styledComponentsRtl.default)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n            left: 0;\n          "]))), theme.dir === 'rtl' && 'content: "”"', space.md, function (_ref5) {
      var theme = _ref5.theme,
        inverse = _ref5.inverse;
      return inverse ? theme.typography.blockquote.quoteColorInverse : theme.typography.blockquote.quoteColor;
    }, function (_ref6) {
      var theme = _ref6.theme;
      return theme.typography.blockquote.quoteSize;
    }, theme.dir === 'rtl' && 'content: "“"', function (_ref7) {
      var theme = _ref7.theme,
        inverse = _ref7.inverse;
      return inverse ? theme.typography.blockquote.quoteColorInverse : theme.typography.blockquote.quoteColor;
    }, function (_ref8) {
      var theme = _ref8.theme;
      return theme.typography.blockquote.quoteSize;
    }, (0, _styledComponentsRtl.default)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n            padding-left: ", ";\n          "])), space.sm));
  }, space.md, space.md, space.md, _list.liStyle, _list.ulStyle, space.lg, (0, _functions.getFontStyle)(typography['ol'], sm), space.sm, _list.olStyle, space.lg, (0, _functions.getFontStyle)(typography['ol'], sm), space.sm, function () {
    var p = typography.p;
    var _getParagraphSize = (0, _functions.getParagraphSize)(p, 'md'),
      min = _getParagraphSize.min,
      max = _getParagraphSize.max;
    return (0, _styledComponents.css)(["", " &.fine,&.fine > *{font-size:", ";}"], (0, _functions.getFontStyle)(typography.p, sm, min, max), typography.p.fontSizeXs);
  }, function () {
    var p = typography.p;
    var _getParagraphSize2 = (0, _functions.getParagraphSize)(p, 'md'),
      min = _getParagraphSize2.min,
      max = _getParagraphSize2.max;
    return (0, _styledComponents.css)(["", " &.fine{font-size:", ";}"], (0, _functions.getFontStyle)(typography.p, sm, min, max), typography.p.fontSizeXs);
  }, function (_ref9) {
    var theme = _ref9.theme;
    return theme.fontSize.xxs;
  }, space.sm, colors.text00, function (_ref10) {
    var theme = _ref10.theme;
    return theme.fontWeight.bold;
  }, function (_ref11) {
    var theme = _ref11.theme;
    return theme.palette.blueGray10;
  }, function (_ref12) {
    var theme = _ref12.theme;
    return theme.fontWeight.semiBold;
  }, colors.text00, function (_ref13) {
    var theme = _ref13.theme;
    return (0, _polished.transparentize)(0.3, theme.colors.ui00);
  }, function (_ref14) {
    var theme = _ref14.theme;
    return theme.palette.blue10;
  }, function (_ref15) {
    var theme = _ref15.theme;
    return theme.palette.blue10;
  }, colors.text00, colors.ui00, colors.text01, function (_ref16) {
    var theme = _ref16.theme;
    return theme.palette.gray10;
  }, colors.text01, function (_ref17) {
    var theme = _ref17.theme;
    return theme.palette.success10;
  }, function (_ref18) {
    var theme = _ref18.theme;
    return theme.palette.success100;
  }, function (_ref19) {
    var theme = _ref19.theme;
    return theme.palette.warning10;
  }, function (_ref20) {
    var theme = _ref20.theme;
    return theme.palette.warning100;
  }, function (_ref21) {
    var theme = _ref21.theme;
    return theme.palette.danger10;
  }, function (_ref22) {
    var theme = _ref22.theme;
    return theme.palette.danger100;
  }, colors.brandPrimary, space.xxs, function (_ref23) {
    var theme = _ref23.theme;
    return theme.palette.white;
  }, function (_ref24) {
    var theme = _ref24.theme;
    return theme.fontWeight.bold;
  }, space.sm, space.lg, colors.brandPrimary, colors.brandPrimary, colors.brandPrimaryInteract, colors.brandPrimary, colors.brandPrimaryInteract, colors.brandPrimary, colors.brandPrimaryInteract, colors.brandPrimary, colors.brandPrimaryInteract, colors.brandPrimary, colors.brandPrimaryInteract, colors.brandPrimary, space.lg, function (_ref25) {
    var theme = _ref25.theme,
      inverse = _ref25.inverse;
    return inverse ? theme.palette.blue50 : theme.palette.gray40;
  }, space.md, function (_ref26) {
    var theme = _ref26.theme;
    return theme.palette.blue10;
  }, function (_ref27) {
    var theme = _ref27.theme;
    return theme.palette.blue100;
  }, space.md, function (_ref28) {
    var theme = _ref28.theme;
    return theme.animation.transitionMedium;
  }, function (_ref29) {
    var theme = _ref29.theme;
    return theme.animation.transitionMedium;
  }, function (_ref30) {
    var theme = _ref30.theme;
    return theme.animation.transitionMedium;
  }, function (_ref31) {
    var theme = _ref31.theme;
    return theme.palette.blue90;
  }, function (_ref32) {
    var theme = _ref32.theme;
    return theme.palette.blue10;
  }, function (_ref33) {
    var theme = _ref33.theme;
    return theme.palette.blue20;
  });
});
var _default = StyledRichText;
exports.default = _default;